import { render } from "./CreateExitDeclarationStatusPage.vue?vue&type=template&id=1a3c9a39"
import script from "./CreateExitDeclarationStatusPage.vue?vue&type=script&lang=js"
export * from "./CreateExitDeclarationStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__